/**
 * version.js
 * Gestisce la versione dell'applicazione e controlla aggiornamenti
 * Il timestamp e la versione vengono aggiornati automaticamente dal build.js
 */

window.AppVersion = (function() {
    // Versione corrente dell'app (aggiornata ad ogni deploy)
    const VERSION = {
        number: 'v6.0.3',  // Valore aggiornato dal build.js con CONFIG.VERSION.NUMBER
        timestamp: '1783992501306',  // Timestamp aggiornato automaticamente dal build.js
        buildDate: new Date().toISOString()
    };
    
    // Salva la versione corrente nel localStorage
    function saveCurrentVersion() {
        try {
            localStorage.setItem('appVersion', JSON.stringify(VERSION));
        } catch (e) {
            console.error('Errore nel salvare la versione:', e);
        }
    }
    
    // Controlla se ci sono aggiornamenti disponibili
    function checkForUpdates() {
        try {
            // Ottieni la versione salvata
            const savedVersionJson = localStorage.getItem('appVersion');
            if (!savedVersionJson) {
                // Prima visita, salva solo la versione corrente
                saveCurrentVersion();
                return;
            }
            
            const savedVersion = JSON.parse(savedVersionJson);
            
            // Se il timestamp è diverso, abbiamo un aggiornamento
            if (savedVersion.timestamp !== VERSION.timestamp) {
                console.log(`Nuova versione rilevata: ${VERSION.number} (${VERSION.timestamp})`);
                
                // Aggiorna la versione salvata
                saveCurrentVersion();
                
                // Se non è un refresh recente, forza il reload
                const lastReload = localStorage.getItem('lastReload');
                const now = Date.now();
                
                if (!lastReload || now - parseInt(lastReload) > 5000) {
                    // Salva il timestamp del reload
                    localStorage.setItem('lastReload', now.toString());
                    
                    // Mostra un messaggio all'utente
                    alert(`Nuova versione disponibile (${VERSION.number}). L'app verrà aggiornata.`);
                    
                    // Forza il reload pulendo la cache
                    window.location.reload(true);
                }
            }
        } catch (e) {
            console.error('Errore nel controllo aggiornamenti:', e);
        }
    }
    
    // Utilità per ottenere il parametro di versione per URL
    function getVersionParam() {
        return `v=${VERSION.timestamp}`;
    }
    
    // Utilità per aggiungere il parametro di versione a un URL
    function addVersionToUrl(url) {
        if (!url) return url;
        
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}${getVersionParam()}`;
    }
    
    // Utilità per ottenere il numero di versione
    function getVersionNumber() {
        return VERSION.number;
    }
    
    // API pubblica
    return {
        VERSION: VERSION,
        checkForUpdates: checkForUpdates,
        getVersionParam: getVersionParam,
        addVersionToUrl: addVersionToUrl,
        getVersionNumber: getVersionNumber
    };
})();
